import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import TranslateButton from '../components/TranslateButton';
import TranslationStatus from '../components/TranslationStatus';
import TranslationState from '../states/TranslationState';
import { actorTargets, isReadersLanguage } from '../utils/targets';
import { closeThread, translateThread } from '../utils/translateThread';

/**
 * The hero title is swapped for its translation in place, with a one-line
 * status underneath; the translate control sits on its own line below the title.
 * The hero acts on the whole thread: translating translates the title and every
 * loaded post that needs it; "Show original" reverts them all.
 */
export default function extendDiscussionHero() {
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    if (!discussion.id()) return;
    const existing = TranslationState.peek(discussion);
    const translation = existing?.active() ?? null;
    const source = discussion.detectedLang?.() ?? null;
    syncDocumentTitle(discussion, translation);
    if (existing && translation) {
      if (items.has('title')) {
        items.setContent('title', m("h1", {
          className: "DiscussionHero-title DiscussionHero-title--translated",
          lang: translation.language()
        }, translation.title()));
      }
      items.add('fof-translate', m(TranslationStatus, {
        className: "DiscussionHero-translation",
        state: existing,
        source: source,
        onClose: () => closeThread(discussion)
      }), -10);
      return;
    }
    const targets = actorTargets();
    const available = isReadersLanguage(source) ? [] : TranslateButton.targetsFor(targets, source, TranslationState.unavailableFor(discussion));
    if (!available.length) return;
    const state = existing ?? TranslationState.for(discussion, 'discussions');
    items.add('fof-translate', m(TranslateButton, {
      className: "DiscussionHero-translate",
      buttonClassName: "Button Button--link",
      state: state,
      targets: targets,
      source: source,
      onTranslate: locale => translateThread(discussion, locale)
    }), -10);
  });
}

/**
 * Keep the browser tab title in step with the hero: translated while the
 * translation is shown, the original otherwise.
 */
function syncDocumentTitle(discussion, translation) {
  if (!app.viewingDiscussion(discussion)) return;
  const title = translation?.title() || discussion.title();
  if (title && app.title !== title) app.setTitle(title);
}
flarum.reg.add('fof-translate', 'forum/extend/extendDiscussionHero', extendDiscussionHero);